import { Link as ScopedLink } from "@/components/Link";
import styled from "styled-components";

export const Link = styled(ScopedLink)`
  width: 40px;
  height: 40px;
  color: inherit;
  padding: ${({ theme }) => theme.spacers.M};
`;
